module.exports = __webpack_public_path__ + "img/bingo_ball-55.076a3fa7.png";